import {observable} from 'mobx';
import suppliesUsageStore from './plans.suppliesUsage.store';

export class PlansStore {
  @observable
  public suppliesUsage = suppliesUsageStore;
}

const plansStore = new PlansStore();
export default plansStore;